import { useState } from 'react';
import { Input } from '@/components/ui/input';

/**
 * Champ de saisie monétaire user-friendly.
 * - Pendant la saisie : texte brut (ex: "5000" ou "5000.95")
 * - Au blur : formate avec 2 décimales (ex: "5 000,00")
 * - Supporte virgule et point comme séparateur décimal
 */
export function MoneyInput({ value, onChange, className = '', placeholder = '0,00', ...props }) {
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState('');

  const formatDisplay = (v) => {
    if (v === 0 || v === '' || v == null) return '';
    if (typeof v === 'number') {
      return v.toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return String(v);
  };

  const handleFocus = () => {
    setEditing(true);
    if (typeof value === 'number' && value !== 0) {
      // Show raw number without thousand separators - use period as decimal
      const raw = Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.?0+$/, '');
      setEditValue(raw);
    } else if (typeof value === 'string' && value !== '') {
      setEditValue(value.replace(',', '.'));
    } else {
      setEditValue('');
    }
  };

  const handleChange = (e) => {
    let val = e.target.value.replace(/\s/g, '').replace(',', '.');
    if (val === '' || /^[0-9]*\.?[0-9]{0,2}$/.test(val)) {
      setEditValue(val);
    }
  };

  const handleBlur = () => {
    setEditing(false);
    const num = parseFloat(editValue) || 0;
    onChange(num);
  };

  return (
    <Input
      type="text"
      inputMode="decimal"
      className={className}
      placeholder={placeholder}
      value={editing ? editValue : formatDisplay(value)}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  );
}
